# frozen_string_literal: true

module Engine
  module Part
  end
end
